import { render, staticRenderFns } from "./Transformer.vue?vue&type=template&id=4eba45c2&"
import script from "./Transformer.vue?vue&type=script&lang=js&"
export * from "./Transformer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports